<cosmos-section
  [loading]="(_loading$ | async) === true"
  sectionTitle="Elements"
  class="cosmos-user-elements__section"
>
  <cosmos-table
    [columns]="_columns"
    [dataSource]="_dataSource"
    [isFilterable]="false"
    [isPaginable]="true"
    (clickedRow)="openElementDetails($event)"
    paginatorType="compact"
  ></cosmos-table>
</cosmos-section>

<ng-template
  #checkboxTemplate
  let-data="row">
  <img
    *ngIf="data.id | featuredElement | async"
    src="assets/icons/tick.svg"
    alt=""
    loading="lazy"
  />
</ng-template>

<ng-template
  #contentTemplate
  let-data="row">
  <div class="cosmos-user-elements__preview">
    <cosmos-element-preview [element]="data"></cosmos-element-preview>
  </div>
</ng-template>
